import React, { useState, useEffect } from 'react';

interface CounterAnimationProps {
  value: number;
  duration?: number;
  className?: string;
}

export const CounterAnimation: React.FC<CounterAnimationProps> = ({
  value,
  duration = 2000,
  className = ""
}) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime: number;
    let animationFrame: number;

    const updateCounter = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);

      // Utilise une fonction d'easing pour un effet plus naturel
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(easeOutQuart * value);

      setCount(currentCount);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(updateCounter);
      } else {
        setCount(value); // S'assurer d'afficher la valeur finale exacte
      }
    };

    // Réinitialiser le compteur et démarrer l'animation
    setCount(0);
    animationFrame = requestAnimationFrame(updateCounter);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [value, duration]);

  return <span className={className}>{count.toLocaleString()}</span>;
};